export default "__VITE_ASSET__DTwxoYUl__"